<template>
  <div class="footer">

    <div class="footer-w">
      <div class="tp">
        <div class="navs">
          <div class="col">
            <div class="ftt">
              <span class="zh">加入</span>
              <span class="en">Join</span>
            </div>
            <a @click="goPage('/join?p=jobs')" class="fstt">
              <span class="zh">工作机会</span>
              <span class="en">Job Opportunities</span>
            </a>
            <a @click="goPage('/join?p=volunteer')" class="fstt">
              <span class="zh">志愿者</span>
              <span class="en">Volunteers</span>
            </a>
          </div>
          <div class="col">
            <div class="ftt">
              <span class="zh">支持</span>
              <span class="en">Support</span>
            </div>
            <a @click="goPage('/join?p=cooperation')" class="fstt">
              <span class="zh">合作与支持</span>
              <span class="en">Support & Collaboration</span>
            </a>
            <a @click="goPage('/support')" class="fstt">
              <span class="zh">展览赞助</span>
              <span class="en">Exhibition Sponsorship</span>
            </a>
            <a @click="goPage('/support')" class="fstt">
              <span class="zh">赞助回馈</span>
              <span class="en">Sponsorship Rewards</span>
            </a>
          </div>
          <div class="col">
            <div class="ftt">
              <span class="zh">关于</span>
              <span class="en">About</span>
            </div>
            <a @click="goPage('/about')" class="fstt">
              <span class="zh">天目里美术馆</span>
              <span class="en">BY ART MATTERS</span>
            </a>
            <a @click="goPage('/media')" class="fstt">
              <span class="zh">媒体中心</span>
              <span class="en">Media Center</span>
            </a>
          </div>
        </div>
        <div class="xcx-w">
          <img class="xcx-qrcode" src="@/assets/images/qrcode20250429.jpg" alt="wechat qrcode"/>
          <p class="xcx-hint">
            <span class="zh">目里小程序</span>
            <span class="en">OōEli Mini Program</span>
          </p>
        </div>
      </div>
      <div class="bp">
        <div class="cp">
          <span class="zh">
© 2025 BY ART MATTERS 天目里美术馆. 慧展科技(杭州)有限公司&nbsp;&nbsp;All rights reserved. <br
              class="display-600 not-display-pc"/><a
              href="https://beian.miit.gov.cn" target="_blank">浙ICP备20006168号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;浙公网安备 33010602010792号&nbsp;&nbsp;&nbsp;&nbsp;<br
              class="display-600 not-display-pc"/>A: 杭州市天目山路398号&nbsp;&nbsp;&nbsp;&nbsp;E: info@byartmatters.com
          </span>
          <span class="en">
            © 2025 BY ART MATTERS. All rights reserved. <br class="display-600 not-display-pc"/><a
              href="https://beian.miit.gov.cn" target="_blank">浙ICP备20006168号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;浙公网安备 33010602010792号&nbsp;&nbsp;&nbsp;&nbsp;<br
              class="display-600 not-display-pc"/>A: 398 Tianmushan Road, Xihu District, Hangzhou, China&nbsp;&nbsp;&nbsp;&nbsp;E: info@byartmatters.com
          </span>
        </div>
        <div class="socials-w">
          <a>
            <div class="show-qrcode" v-if="footerShowQrcode.wx">
              <img src="@/assets/images/sc-qr-wx.png"/>
              <span class="zh">关注我们</span>
              <span class="en">Follow us</span>
            </div>
            <img class="social" src="@/assets/images/social-wechat.png" alt="wechat" @click="showQrcode('wx')"/>
          </a>
          <a>
            <div class="show-qrcode" v-if="footerShowQrcode.xhs">
              <img src="@/assets/images/sc-qr-xhs.png"/>
              <span class="zh">关注我们</span>
              <span class="en">Follow us</span>
            </div>
            <img class="social" src="@/assets/images/social-xhs.png" alt="小红书" @click="showQrcode('xhs')"/>
          </a>
          <a href="https://space.bilibili.com/2036381501?spm_id_from=333.337.0.0" target="_blank">
            <img class="social" src="@/assets/images/social-blbl.png" alt="instagram"/>
          </a>
          <a>
            <div class="show-qrcode" v-if="footerShowQrcode.ig">
              <img src="@/assets/images/sc-qr-ig.png"/>
              <span class="zh">关注我们</span>
              <span class="en">Follow us</span>
            </div>
            <img class="social" src="@/assets/images/social-insta2.png" alt="instagram" @click="showQrcode('ig')"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerComponent",
  components: {},
  data() {
    return {
      footerShowQrcode: {
        'wx': false,
        'xhs': false,
        'ig': false
      }
    }
  },
  methods: {
    goPage(path) {
      this.$router.push(path);
    },

    showQrcode(ty) {
      let mp = {
        'wx': false,
        'xhs': false,
        'ig': false
      }
      mp[ty] = true
      this.footerShowQrcode = mp
    }
  }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue